export { default as VictoryLegend } from "./victory-legend";


//////////////////
// WEBPACK FOOTER
// ./~/victory-legend/es/index.js
// module id = ./node_modules/victory-legend/es/index.js
// module chunks = 1